import {
  handleResponse,
  handleError,
} from "./apiUtils";
import { saveAs } from "file-saver";
const baseUrlCompany = (process.env.REACT_APP_API_URL || "") + "/api/company/";

//Get all companies
export function getCompanies() {
  return fetch(baseUrlCompany, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Get one company by companyId
export function getCompany(companyId) {
  return fetch(baseUrlCompany + companyId, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getSelectedCompanies() {
  if (sessionStorage.getItem("token")) {
    return fetch("/api/selectedCompany", {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    })
      .then(handleResponse)
      .catch(handleError);
  }
}

export function selectedCompany(companyId) {
  if (sessionStorage.getItem("token")) {
    return fetch("/api/selectedCompany", {
      method: "PUT",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(companyId),
    })
      .then(handleResponse)
      .catch(handleError);
  }
}

export function getCompanyTypes() {
  return fetch("/api/types/companytypes", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Get all the users by companyId
export function getUsers(companyId) {
  return fetch(baseUrlCompany + companyId + "/users", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getCompaniesByOrg(orgName, companyId = 0) {
  orgName = orgName.toUpperCase();
  const url = companyId
    ? baseUrlCompany + "Org/" + orgName + "?companyId=" + companyId
    : baseUrlCompany + "Org/" + orgName;
  return fetch(url, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Update or Create company
export async function saveCompany(company, returnError = false) {
  try {
    const response = await fetch(baseUrlCompany + (company.companyId || ""), {
      method: company.companyId ? "PUT" : "POST",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(company),
    });
    return await handleResponse(response, returnError);
  } catch (error) {
    return handleError(error);
  }
}

export async function saveTFFCode(companyId, code, returnError = true) {
  try {
    const response = await fetch(
      baseUrlCompany + "AddTffCode?companyId=" + companyId + "&code=" + code,
      {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
          "Content-Type": "application/json",
        }),
      }
    );
    return handleResponse(response, returnError);
  } catch (error) {
    return handleError(error);
  }
}


export async function setMainTFFCode(companyId, code, returnError = true) {
  try {
    const response = await fetch(
      baseUrlCompany + "SetMainTffCode?companyId=" + companyId + "&code=" + code,
      {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
          "Content-Type": "application/json",
        }),
      }
    );
    return handleResponse(response, returnError);
  } catch (error) {
    return handleError(error);
  }
}


//Delete company
export function deleteCompany(companyId) {
  return fetch(baseUrlCompany + companyId, {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.getItem("token").clear();
        return undefined;
      } else if (response.ok) {
        return response;
      } else {
        return false;
      }
      // if (response.status === 400) {
      //   // So, a server-side validation error occurred.
      //   // Server side validation returns a string error message, so parse as text instead of json.
      //   const error = await response.text();
      //   throw new Error(error);
      // }
      // throw new Error("Network response was not ok.");
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

export function deleteTFFCode(code) {
  return fetch(baseUrlCompany + "DeleteTffCode?tffCode=" + code, {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.getItem("token").clear();
        return undefined;
      } else if (response.ok) {
        return response;
      } else {
        return false;
      }
      // if (response.status === 400) {
      //   // So, a server-side validation error occurred.
      //   // Server side validation returns a string error message, so parse as text instead of json.
      //   const error = await response.text();
      //   throw new Error(error);
      // }
      // throw new Error("Network response was not ok.");
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

//Get current membershipstatus(TFF/YFF) for company
export function getCompanyStatus(companyId, organisationName) {
  return fetch(
    baseUrlCompany +
      companyId +
      "/" +
      organisationName +
      "/NewStatusSuggestion",
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

//Get all membership status for company
export function getMembershipStatusForCompany(companyId, organisationName) {
  return fetch(baseUrlCompany + companyId + "/" + organisationName, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Create new company status
export function createCompanyStatus(companyId, orgName, companyStatus) {
  return fetch(baseUrlCompany + companyId + "/" + orgName + "/NewMember", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(companyStatus),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Update company status
export function updateCompanyStatus(companyId, orgName, companyStatus) {
  return fetch(baseUrlCompany + companyId + "/" + orgName + "/NewStatus", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(companyStatus),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Get reported prize history for company in organisation
export function getPrizeHistory(companyId, organisationName, type) {
  return fetch(
    baseUrlCompany + companyId + "/" + organisationName + "/" + type,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function getCapitalCallHistory(companyId, organisationName) {
  return fetch(
    baseUrlCompany + companyId + "/" + organisationName + "/SummoningHistory",
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

//Download execl for vintage
export function getExcelFilePrizeHistory(
  companyId,
  organisationName,
  type,
  download
) {
  return fetch(
    baseUrlCompany +
      companyId +
      "/" +
      organisationName +
      "/" +
      type +
      "?export=" +
      download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function getExcelFileCapitalCallHistory(
  companyId,
  organisationName,
  download
) {
  return fetch(
    baseUrlCompany +
      companyId +
      "/" +
      organisationName +
      "/SummoningHistory?export=" +
      download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function createNewCompany(company) {
  return fetch("/api/selectedCompany", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(company),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteNewCompany(company) {
  return fetch("/api/selectedCompany", {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(company),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.getItem("token").clear();
        return undefined;
      } else if (response.ok) {
        return true;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}
